import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import LocalTime from '@components/Details/LocalTime'
import Avatar from '@components/Avatar/Avatar'
import Header from '../../components/Details/Header'

class EmployeeHeader extends Component {
  static propTypes = {
    employeeStore: PropTypes.object,
    staticData: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object
  }

  renderLocalTime = () => {
    const { employee } = this.props.employeeStore
    const timezoneId = employee.address.timezoneId
    if (!timezoneId) return

    return <LocalTime timezoneId={timezoneId} />
  }

  render () {
    const { employeeStore, staticData, history, match } = this.props
    const { employee } = employeeStore
    const { employeePositions } = staticData.names
    if (!employee) return null

    const avatarPath =
      employee && employee.picture ? employee.picture.path : null

    const urlMatch = match.url.match(/search/)
    const isLinkToFullPage = urlMatch && urlMatch.length > 0

    return (
      <Header>
        <Avatar alt='Expert avatar' src={avatarPath} />

        <div className='info'>
          <div>
            <div className='name-status-wrapper'>
              <h1
                className={`${isLinkToFullPage ? 'title-link' : ''} m-r-sm`}
                onClick={() =>
                  isLinkToFullPage && history.push(`/employee/${employee.id}`)
                }
              >
                {employee.title} {employee.fullName}
              </h1>
            </div>
            <span className='code-label'>
              {employeePositions[employee.currentPosition.employeePositionId]}
              {', '}
              {employee.employee.atheneumOffice.name}
            </span>
          </div>
        </div>
        {this.renderLocalTime()}
      </Header>
    )
  }
}

export default withRouter(
  inject('employeeStore', 'staticData')(observer(EmployeeHeader))
)
